import {
    IServiceServiceMock
} from './index'

export const mockServiceService = (): IServiceServiceMock => ({
    getAllTypes: jest.fn(),
    getTypeById: jest.fn(),
    getAllTypePrices: jest.fn(),
    getTypePriceById: jest.fn(),
    getAllSolutions: jest.fn(),
    getSolutionById: jest.fn(),
    setRequestServiceContact: jest.fn(),
    getRequestServiceHistories: jest.fn()
})
